import { motion } from 'framer-motion'

export default function PharmaCard({ title, desc, icon, className = '' }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.35, ease: 'easeOut' }}
      className={
        'h-full rounded-2xl border border-slate-200 bg-white/70 backdrop-blur px-5 py-5 shadow-sm ' +
        className
      }
    >
      <div className="flex items-start gap-3">
        {icon ? (
          <div className="mt-0.5 w-10 h-10 rounded-xl bg-brand-primary/10 border border-brand-primary/20 flex items-center justify-center text-brand-primary">
            {icon}
          </div>
        ) : null}
        <div>
          {title ? <div className="font-extrabold text-slate-900 text-lg">{title}</div> : null}
          {desc ? <p className="mt-2 text-sm sm:text-[15px] text-slate-600 leading-relaxed">{desc}</p> : null}
        </div>
      </div>
    </motion.div>
  )
}

